/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { MaterialDetailBase } from "../../../../schema/generated/MaterialDetail";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class MaterialDetailDataApi extends EntityDataApi<MaterialDetailBase> {
  public readonly def = idbEntityDefs.MaterialDetail;
}